


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  FiArrowLeft,
  FiRefreshCw,
  FiCalendar,
  FiUsers,
  FiAward,
  FiTrendingUp,
  FiChevronRight,
  FiX,
  FiCheckCircle,
  FiXCircle,
  FiBarChart2,
  FiClock,
  FiLayers
} from 'react-icons/fi';

const BASE_URL = 'https://rvapi.emedha.in/pages/api';

const colors = {
  orange: '#f35018',
  blue: '#2f3194',
  textMain: '#0f1137',
  muted: '#64748b',
  bgLight: '#f4f5fc',
  cardBg: '#ffffff',
  border: 'rgba(47, 49, 148, 0.08)',
  success: '#10b981',
  danger: '#ef4444',
  gold: '#d97706',
};

export default function QuizResults() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);

  // Modal breakdown
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [participantBreakdown, setParticipantBreakdown] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingBreakdown, setLoadingBreakdown] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem('user');
    if (stored) {
      const parsed = JSON.parse(stored);
      setUser(parsed);
      initData(parsed.id || parsed.user_id);
    }
  }, []);

  const initData = async (uid) => {
    try {
      setLoading(true);
      const evRes = await axios.get(`${BASE_URL}/api/events?userId=${uid}`).catch(() => {
        return axios.get(`${BASE_URL}/events?userId=${uid}`);
      });

      if (Array.isArray(evRes.data)) {
        setEvents(evRes.data);
      }

      await loadSessions(uid, null);
    } catch (err) {
      console.error('Initialization error:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadSessions = async (uid, eventId = null) => {
    try {
      let url = `${BASE_URL}/api/analytics/sessions?userId=${uid}`;
      if (eventId) url += `&eventId=${eventId}`;

      const res = await axios.get(url).catch(() => {
        let fallbackUrl = `${BASE_URL}/analytics/sessions?userId=${uid}`;
        if (eventId) fallbackUrl += `&eventId=${eventId}`;
        return axios.get(fallbackUrl);
      });

      if (Array.isArray(res.data)) {
        setSessions(res.data);
        if (res.data.length > 0) {
          handleSelectSession(res.data[0]);
        } else {
          setSelectedSession(null);
          setLeaderboard([]);
        }
      }
    } catch (err) {
      console.error('Load sessions error:', err);
    }
  };

  const handleEventFilterChange = (e) => {
    const val = e.target.value === 'all' ? null : parseInt(e.target.value, 10);
    setSelectedEventId(val);
    if (user) {
      loadSessions(user.id || user.user_id, val);
    }
  };

  // const handleSelectSession = async (session) => {
  //   setSelectedSession(session);
  //   try {
  //     setLoadingDetails(true);
  //     const res = await axios.get(`${BASE_URL}/api/analytics/session-results/${session.room_pin}`);
  //     if (Array.isArray(res.data)) {
  //       setLeaderboard(res.data);
  //     }
  //   } catch (err) {
  //     console.error('Session details error:', err);
  //   } finally {
  //     setLoadingDetails(false);
  //   }
  // };


const handleSelectSession = async (session) => {
    setSelectedSession(session);
    try {
      setLoadingDetails(true);
      // 👉 Pass session_type ('live' or 'self_paced')
      const sessionType = session.session_type || 'live';
      const res = await axios.get(`${BASE_URL}/api/analytics/session-results/${session.room_pin}?type=${sessionType}`);
      if (Array.isArray(res.data)) {
        setLeaderboard(res.data);
      }
    } catch (err) {
      console.error('Session details error:', err);
    } finally {
      setLoadingDetails(false);
    }
  };

  // const handleOpenBreakdown = async (participant) => {
  //   setSelectedParticipant(participant);
  //   setIsModalOpen(true);
  //   setLoadingBreakdown(true);
  //   try {
  //     const res = await axios.get(`${BASE_URL}/api/analytics/participant-breakdown/${participant.result_id}`);
  //     if (Array.isArray(res.data)) {
  //       setParticipantBreakdown(res.data);
  //     }
  //   } catch (err) {
  //     console.error('Breakdown error:', err);
  //     setParticipantBreakdown([]);
  //   } finally {
  //     setLoadingBreakdown(false);
  //   }
  // };


const handleOpenBreakdown = async (participant) => {
    setSelectedParticipant(participant);
    setIsModalOpen(true);
    setLoadingBreakdown(true);
    try {
      // 👉 Pass selectedSession.session_type ('live' or 'self_paced')
      const sessionType = selectedSession?.session_type || 'live';
      const res = await axios.get(`${BASE_URL}/api/analytics/participant-breakdown/${participant.result_id}?type=${sessionType}`);
      if (Array.isArray(res.data)) {
        setParticipantBreakdown(res.data);
      }
    } catch (err) {
      console.error('Breakdown error:', err);
      setParticipantBreakdown([]);
    } finally {
      setLoadingBreakdown(false);
    }
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return { date: 'N/A', time: '' };
    const d = new Date(dateStr);
    return {
      date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    };
  };

  return (
    <div style={styles.pageWrapper}>
      {/* 1. TOP WHITE MANAGEMENT BAR (Exact CertificateDesigner style) */}
      <div style={styles.topBar}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>
          <FiArrowLeft size={14} /> Back to Dashboard
        </button>

        <div style={styles.titleWrap}>
          <FiBarChart2 size={20} color={colors.blue} />
          <h2 style={styles.titleHeading}>Analytics &amp; Results </h2>
        </div>

        <button
          onClick={() => user && loadSessions(user.id || user.user_id, selectedEventId)}
          style={styles.refreshBtn}
          title="Refresh Data"
        >
          <FiRefreshCw size={13} color={colors.blue} /> Refresh Logs
        </button>
      </div>

      <div style={styles.mainContainer}>
        {/* 2. EVENT SCOPE FILTER CARD */}
        <div style={styles.filterCard}>
          <div style={styles.filterHeader}>
            <FiLayers size={15} color={colors.blue} />
            <span style={styles.filterLabel}>SELECT TARGET EVENT CONTEXT</span>
          </div>
          <select
            style={styles.eventSelect}
            value={selectedEventId === null ? 'all' : selectedEventId}
            onChange={handleEventFilterChange}
          >
            <option value="all">All Events ({events.length} Active Events)</option>
            {events.map((ev) => (
              <option key={ev.id} value={ev.id}>
                {ev.name} (Event ID: #{ev.id})
              </option>
            ))}
          </select>
        </div>

        {/* 3. HORIZONTAL MATCH SESSIONS CAROUSEL */}
        <div style={{ marginBottom: '24px' }}>
          <span style={styles.sectionHeading}>Quiz SESSIONS ({sessions.length})</span>
          {sessions.length === 0 ? (
            <div style={styles.emptyCard}>
              <span style={{ color: colors.muted, fontSize: '13px' }}>
                No active or historical match sessions recorded for this event.
              </span>
            </div>
          ) : (
            <div style={styles.sessionsRow}>
              {/* {sessions.map((s) => {
                const isSelected = selectedSession?.id === s.id;
                const { date, time } = formatDateTime(s.created_at);

                return (
                  <div
                    key={s.id}
                    onClick={() => handleSelectSession(s)}
                    style={{
                      ...styles.sessionTile,
                      borderColor: isSelected ? colors.orange : colors.border,
                      boxShadow: isSelected
                        ? '0 6px 18px rgba(243, 80, 24, 0.15)'
                        : '0 2px 6px rgba(0, 0, 0, 0.03)',
                      backgroundColor: isSelected ? '#fffaf8' : '#ffffff',
                    }}
                  >
                    <div style={styles.tileHeader}>
                      <span
                        style={{
                          ...styles.tileTitle,
                          color: isSelected ? colors.orange : colors.textMain,
                        }}
                      >
                        {s.event_name || 'Live Event'}
                      </span>
                      <span
                        style={{
                          ...styles.tileDot,
                          backgroundColor: isSelected ? colors.orange : '#cbd5e1',
                        }}
                      />
                    </div>
                    <div style={styles.tileDateRow}>
                      <FiCalendar size={12} color={colors.muted} />
                      <span style={styles.tileDateText}>
                        {date} • {time}
                      </span>
                    </div>
                    <div style={styles.tileFooterRow}>
                      <FiUsers size={12} color={colors.muted} />
                      <span style={styles.tilePlayerCount}>{s.total_participants} Players</span>
                      <span style={styles.pinTag}>PIN #{s.room_pin}</span>
                    </div>
                  </div>
                );
              })} */}
              {sessions.map((s) => {
                const isSelected = selectedSession?.id === s.id && selectedSession?.session_type === s.session_type;
                const isSelfPaced = s.session_type === 'self_paced';
                const { date, time } = formatDateTime(s.created_at);

                return (
                  <div
                    key={`${s.session_type}-${s.id}`}
                    onClick={() => handleSelectSession(s)}
                    style={{
                      ...styles.sessionTile,
                      borderColor: isSelected ? (isSelfPaced ? '#0284c7' : colors.orange) : colors.border,
                      boxShadow: isSelected
                        ? `0 6px 18px ${isSelfPaced ? 'rgba(2, 132, 199, 0.18)' : 'rgba(243, 80, 24, 0.15)'}`
                        : '0 2px 6px rgba(0, 0, 0, 0.03)',
                      backgroundColor: isSelected ? (isSelfPaced ? '#f0f9ff' : '#fffaf8') : '#ffffff',
                    }}
                  >
                    <div style={styles.tileHeader}>
                      <span
                        style={{
                          ...styles.tileTitle,
                          color: isSelected ? (isSelfPaced ? '#0284c7' : colors.orange) : colors.textMain,
                        }}
                      >
                        {s.event_name || 'Quiz Event'}
                      </span>
                      <span
                        style={{
                          fontSize: '9px',
                          fontWeight: '800',
                          padding: '2px 6px',
                          borderRadius: '6px',
                          backgroundColor: isSelfPaced ? 'rgba(2, 132, 199, 0.12)' : 'rgba(243, 80, 24, 0.12)',
                          color: isSelfPaced ? '#0284c7' : colors.orange,
                          textTransform: 'uppercase',
                        }}
                      >
                        {isSelfPaced ? '⚡ Self-Paced' : '🎮 Live'}
                      </span>
                    </div>
                    <div style={styles.tileDateRow}>
                      <FiCalendar size={12} color={colors.muted} />
                      <span style={styles.tileDateText}>
                        {date} • {time}
                      </span>
                    </div>
                    <div style={styles.tileFooterRow}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <FiUsers size={12} color={colors.muted} />
                        <span style={styles.tilePlayerCount}>{s.total_participants} Players</span>
                      </div>
                      <span
                        style={{
                          ...styles.pinTag,
                          backgroundColor: isSelfPaced ? 'rgba(2, 132, 199, 0.1)' : 'rgba(47, 49, 148, 0.08)',
                          color: isSelfPaced ? '#0284c7' : colors.blue,
                        }}
                      >
                        {isSelfPaced ? `CODE #${s.room_pin}` : `PIN #${s.room_pin}`}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* 4. EXECUTIVE METRIC KPI TILES */}
        {selectedSession && (
          <div style={styles.kpiRow}>
            <div style={styles.kpiBox}>
              <div style={styles.kpiIconBox(colors.blue)}>
                <FiUsers size={20} color={colors.blue} />
              </div>
              <div>
                <span style={styles.kpiLabel}>TOTAL PARTICIPANTS</span>
                <h3 style={styles.kpiValue}>
                  {selectedSession.total_participants || leaderboard.length}
                </h3>
                <span style={styles.kpiMeta}>Attended session</span>
              </div>
            </div>

            <div style={styles.kpiBox}>
              <div style={styles.kpiIconBox(colors.gold)}>
                <FiAward size={20} color={colors.gold} />
              </div>
              <div>
                <span style={styles.kpiLabel}>TOP SCORE</span>
                <h3 style={{ ...styles.kpiValue, color: colors.gold }}>
                  {selectedSession.highest_score || leaderboard[0]?.total_marks || 0}
                </h3>
                <span style={styles.kpiMeta}>Highest marks achieved</span>
              </div>
            </div>

            <div style={styles.kpiBox}>
              <div style={styles.kpiIconBox(colors.orange)}>
                <FiTrendingUp size={20} color={colors.orange} />
              </div>
              <div>
                <span style={styles.kpiLabel}>AVERAGE ROUND SCORE</span>
                <h3 style={{ ...styles.kpiValue, color: colors.orange }}>
                  {selectedSession.average_score || 0}
                </h3>
                <span style={styles.kpiMeta}>Class group average</span>
              </div>
            </div>
          </div>
        )}

        {/* 5. PARTICIPANT LEADERBOARD TABLE CARD */}
        <div style={styles.tableCard}>
          <div style={styles.tableHeaderBar}>
            <div>
              <h3 style={styles.tableTitle}>Participant Standings ({leaderboard.length})</h3>
              <p style={styles.tableSub}>Click any participant row to audit question accuracy and response speed.</p>
            </div>
            <span style={styles.sortPill}>Sorted by Total Score</span>
          </div>

          {loadingDetails ? (
            <div style={styles.centerLoader}>
              <FiRefreshCw className="spin" size={24} color={colors.blue} />
              <span style={styles.loaderText}>Extracting scorecard logs...</span>
            </div>
          ) : leaderboard.length === 0 ? (
            <div style={styles.emptyCard}>
              <h5 style={{ margin: '0 0 4px 0', color: colors.textMain, fontWeight: '700' }}>No Scores Recorded</h5>
              <p style={{ margin: 0, color: colors.muted, fontSize: '13px' }}>
                No participants registered responses for this session yet.
              </p>
            </div>
          ) : (
            <div style={styles.tableList}>
              {leaderboard.map((item, index) => {
                const isTop3 = index < 3;
                const badges = ['🥇', '🥈', '🥉'];

                return (
                  <div
                    key={item.result_id || index}
                    onClick={() => handleOpenBreakdown(item)}
                    style={{
                      ...styles.participantRow,
                      backgroundColor: isTop3 ? '#fafbff' : '#ffffff',
                      borderColor: isTop3 ? 'rgba(47, 49, 148, 0.16)' : colors.border,
                    }}
                  >
                    <div style={styles.rankBadge}>
                      {isTop3 ? (
                        <span style={{ fontSize: '20px' }}>{badges[index]}</span>
                      ) : (
                        <span style={styles.regularRank}>#{index + 1}</span>
                      )}
                    </div>

                    <div style={styles.playerInfo}>
                      <span style={styles.playerNameText}>{item.name || 'Anonymous Player'}</span>
                      <span style={styles.playerContactText}>
                        {item.email} • 📞 {item.mobile || 'N/A'}
                      </span>
                      <div style={styles.badgesRow}>
                        <span style={styles.accuracyTag}>✅ {item.correct_answers || 0} Correct</span>
                        <span style={styles.timeTag}>⏱️ {item.total_time_taken || 0}s Taken</span>
                      </div>
                    </div>

                    <div style={styles.scoreContainer}>
                      <span style={styles.scoreNumber}>{item.total_marks}</span>
                      <span style={styles.ptsText}>PTS</span>
                      <FiChevronRight size={16} color={colors.muted} style={{ marginTop: '2px' }} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* 6. MODAL: PARTICIPANT BREAKDOWN */}
      {isModalOpen && (
        <div style={styles.modalBackdrop}>
          <div style={styles.modalCard}>
            <div style={styles.modalHeader}>
              <div>
                <h4 style={styles.modalTitleText}>{selectedParticipant?.name}</h4>
                <span style={styles.modalSubtitleText}>Question-by-Question Response Audit</span>
              </div>
              <button style={styles.modalCloseBtn} onClick={() => setIsModalOpen(false)}>
                <FiX size={18} color="#64748b" />
              </button>
            </div>

            <div style={styles.modalContentBody}>
              {loadingBreakdown ? (
                <div style={styles.centerLoader}>
                  <FiRefreshCw className="spin" size={22} color={colors.blue} />
                  <span style={styles.loaderText}>Loading question breakdown...</span>
                </div>
              ) : participantBreakdown.length === 0 ? (
                <p style={{ textAlign: 'center', color: colors.muted, fontSize: '13px' }}>
                  No question logs found for this participant.
                </p>
              ) : (
                participantBreakdown.map((log, lIdx) => {
                  const isCorrect = log.is_correct === 1;
                  return (
                    <div key={log.id || lIdx} style={styles.breakdownCard}>
                      <div style={styles.breakdownCardTop}>
                        <span
                          style={{
                            ...styles.statusTag,
                            backgroundColor: isCorrect ? '#ecfdf5' : '#fff1f2',
                            color: isCorrect ? colors.success : colors.danger,
                            borderColor: isCorrect ? '#a7f3d0' : '#fecdd3',
                          }}
                        >
                          {isCorrect ? (
                            <FiCheckCircle size={12} style={{ marginRight: '4px' }} />
                          ) : (
                            <FiXCircle size={12} style={{ marginRight: '4px' }} />
                          )}
                          {isCorrect ? 'CORRECT' : 'INCORRECT'}
                        </span>
                        <span style={styles.pointsEarned}>+{log.points_awarded || 0} pts</span>
                      </div>

                      <p style={styles.questionText}>
                        {lIdx + 1}. {log.question || 'Quiz Question'}
                      </p>

                      <div style={styles.metaRow}>
                        <span style={styles.targetAnswer}>Target Answer: <strong>{log.correct_answer || 'N/A'}</strong></span>
                        <span style={styles.timeTaken}>⏱️ {log.seconds_taken || 0}s</span>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  pageWrapper: {
    minHeight: '100vh',
    backgroundColor: colors.bgLight,
    fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: colors.textMain,
  },
  topBar: {
    backgroundColor: '#ffffff',
    padding: '14px 28px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    borderBottom: '1px solid rgba(47, 49, 148, 0.08)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#f1f5f9',
    border: 'none',
    padding: '8px 14px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: colors.textMain,
    cursor: 'pointer',
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  titleHeading: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '800',
    color: colors.textMain,
  },
  refreshBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(47, 49, 148, 0.05)',
    color: colors.blue,
    border: '1px solid rgba(47, 49, 148, 0.15)',
    padding: '8px 14px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '700',
    cursor: 'pointer',
  },
  mainContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '24px 20px 60px 20px',
  },
  filterCard: {
    backgroundColor: '#ffffff',
    padding: '16px 20px',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.02)',
    border: `1px solid ${colors.border}`,
    marginBottom: '20px',
  },
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '8px',
  },
  filterLabel: {
    fontSize: '11px',
    fontWeight: '800',
    color: colors.muted,
    letterSpacing: '0.8px',
  },
  eventSelect: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '10px',
    border: '1.5px solid #cbd5e1',
    backgroundColor: '#fafbfc',
    fontSize: '14px',
    fontWeight: '600',
    color: colors.textMain,
    outline: 'none',
    cursor: 'pointer',
  },
  sectionHeading: {
    fontSize: '11px',
    fontWeight: '800',
    color: colors.muted,
    letterSpacing: '0.8px',
    display: 'block',
    marginBottom: '10px',
  },
  sessionsRow: {
    display: 'flex',
    gap: '12px',
    overflowX: 'auto',
    paddingBottom: '8px',
  },
  sessionTile: {
    minWidth: '220px',
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    padding: '14px',
    border: `1.5px solid ${colors.border}`,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    flexShrink: 0,
  },
  tileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
  },
  tileTitle: {
    fontSize: '13px',
    fontWeight: '800',
    maxWidth: '170px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tileDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
  },
  tileDateRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '8px',
  },
  tileDateText: {
    fontSize: '11px',
    color: colors.muted,
    fontWeight: '600',
  },
  tileFooterRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tilePlayerCount: {
    fontSize: '11px',
    color: colors.muted,
    fontWeight: '600',
  },
  pinTag: {
    fontSize: '10px',
    fontWeight: '800',
    color: colors.blue,
    backgroundColor: 'rgba(47, 49, 148, 0.08)',
    padding: '2px 6px',
    borderRadius: '6px',
  },
  kpiRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '14px',
    marginBottom: '24px',
  },
  kpiBox: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '18px 20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.02)',
    border: `1px solid ${colors.border}`,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  kpiIconBox: (col) => ({
    width: '46px',
    height: '46px',
    borderRadius: '12px',
    backgroundColor: `${col}12`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  kpiLabel: {
    fontSize: '10px',
    fontWeight: '800',
    color: colors.muted,
    letterSpacing: '0.8px',
    display: 'block',
  },
  kpiValue: {
    fontSize: '24px',
    fontWeight: '900',
    margin: '2px 0',
    color: colors.textMain,
  },
  kpiMeta: {
    fontSize: '11px',
    color: colors.muted,
  },
  tableCard: {
    backgroundColor: '#ffffff',
    borderRadius: '18px',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.03)',
    border: `1px solid ${colors.border}`,
    padding: '22px',
  },
  tableHeaderBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '10px',
  },
  tableTitle: {
    margin: '0 0 2px 0',
    fontSize: '16px',
    fontWeight: '800',
    color: colors.textMain,
  },
  tableSub: {
    margin: 0,
    fontSize: '12px',
    color: colors.muted,
  },
  sortPill: {
    fontSize: '11px',
    fontWeight: '700',
    color: colors.blue,
    backgroundColor: 'rgba(47, 49, 148, 0.06)',
    padding: '4px 10px',
    borderRadius: '20px',
  },
  tableList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  participantRow: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '12px',
    padding: '14px 16px',
    border: `1px solid ${colors.border}`,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
  },
  rankBadge: {
    width: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  regularRank: {
    fontSize: '14px',
    fontWeight: '800',
    color: colors.muted,
  },
  playerInfo: {
    flex: 1,
  },
  playerNameText: {
    fontSize: '14px',
    fontWeight: '800',
    color: colors.textMain,
    display: 'block',
  },
  playerContactText: {
    fontSize: '12px',
    color: colors.muted,
    margin: '2px 0 6px 0',
    display: 'block',
  },
  badgesRow: {
    display: 'flex',
    gap: '12px',
  },
  accuracyTag: {
    fontSize: '11px',
    fontWeight: '700',
    color: colors.success,
  },
  timeTag: {
    fontSize: '11px',
    fontWeight: '700',
    color: colors.blue,
  },
  scoreContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginLeft: '12px',
  },
  scoreNumber: {
    fontSize: '20px',
    fontWeight: '900',
    color: colors.gold,
    lineHeight: 1,
  },
  ptsText: {
    fontSize: '9px',
    fontWeight: '800',
    color: colors.muted,
  },
  centerLoader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0',
  },
  loaderText: {
    marginTop: '10px',
    color: colors.muted,
    fontSize: '13px',
  },
  emptyCard: {
    backgroundColor: '#fafbfc',
    borderRadius: '12px',
    padding: '30px',
    textAlign: 'center',
    border: `1px dashed ${colors.border}`,
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 17, 55, 0.65)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  modalCard: {
    backgroundColor: '#ffffff',
    borderRadius: '18px',
    width: '100%',
    maxWidth: '560px',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
  },
  modalHeader: {
    padding: '18px 22px',
    borderBottom: `1px solid ${colors.border}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitleText: {
    margin: '0 0 2px 0',
    fontSize: '16px',
    fontWeight: '800',
    color: colors.textMain,
  },
  modalSubtitleText: {
    fontSize: '12px',
    color: colors.muted,
  },
  modalCloseBtn: {
    background: '#f1f5f9',
    border: 'none',
    width: '32px',
    height: '32px',
    borderRadius: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContentBody: {
    padding: '20px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  breakdownCard: {
    backgroundColor: '#fafbfc',
    borderRadius: '12px',
    padding: '14px',
    border: `1px solid ${colors.border}`,
  },
  breakdownCardTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  statusTag: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: '6px',
    fontSize: '10px',
    fontWeight: '800',
    borderWidth: '1px',
    borderStyle: 'solid',
  },
  pointsEarned: {
    fontSize: '12px',
    fontWeight: '800',
    color: colors.gold,
  },
  questionText: {
    fontSize: '13px',
    fontWeight: '700',
    color: colors.textMain,
    margin: '0 0 8px 0',
    lineHeight: '1.4',
  },
  metaRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '11px',
    color: colors.muted,
  },
  targetAnswer: {
    color: colors.textMain,
  },
  timeTaken: {
    color: colors.muted,
  },
};
